import {
  Sidebar,
  SidebarDivider,
  SidebarGroup,
  SidebarItem,
  SidebarScrollWrapper,
  SidebarSpace,
} from '@backstage/core-components';
import { NavContentBlueprint } from '@backstage/plugin-app-react';
import { SidebarLogo } from './SidebarLogo';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import { SidebarSearchModal } from '@backstage/plugin-search';
import { UserSettingsSignInAvatar } from '@backstage/plugin-user-settings';
import { usePermission } from '@backstage/plugin-permission-react';
import { policyEntityReadPermission } from '@backstage-community/plugin-rbac-common';

export const SidebarContent = NavContentBlueprint.make({
  params: {
    component: ({ navItems }) => {
      const nav = navItems.withComponent(item => (
        <SidebarItem icon={() => item.icon} to={item.href} text={item.title} />
      ));

      // eslint-disable-next-line react-hooks/rules-of-hooks
      const { allowed: isAdmin } = usePermission({
        permission: policyEntityReadPermission,
        resourceRef: undefined,
      });

      // Skipped items
      nav.take('page:search'); // Using search modal instead
      nav.take('page:catalog-graph'); // Hidden for everyone
      nav.take('page:notifications'); // Hidden for everyone
      nav.take('page:app-visualizer'); // Hidden for everyone

      // The scaffolder page (upstream title "Create") is rendered manually so
      // we can rename it to "Self Services" and place it before the catalog.
      // Taken from the raw collection (shared taken-state with `nav`).
      const selfServiceItem = navItems.take('page:scaffolder');

      // Pull these out of nav.rest() so they only render for admins.
      const rbacItem = nav.take('page:rbac');
      const registerItem = nav.take('page:catalog-import');

      return (
        <Sidebar>
          <SidebarLogo />
          {/* Extra breathing room between the logo and the first menu item. */}
          <div style={{ height: 32 }} />
          {/* Home sits at the top. */}
          {nav.take('page:home')}
          <SidebarGroup label="Menu" icon={<MenuIcon />}>
            {/* Self Services (scaffolder) above the catalog. */}
            {selfServiceItem && (
              <SidebarItem
                icon={() => selfServiceItem.icon}
                to={selfServiceItem.href}
                text="Self Services"
              />
            )}
            {nav.take('page:catalog')}
            <SidebarDivider />
            <SidebarScrollWrapper>
              {nav.rest({ sortBy: 'title' })}
              {isAdmin && registerItem}
              {isAdmin && rbacItem}
            </SidebarScrollWrapper>
          </SidebarGroup>
          <SidebarSpace />
          <SidebarDivider />
          {/* Search sits at the bottom, just above Settings. */}
          <SidebarGroup label="Search" icon={<SearchIcon />} to="/search">
            <SidebarSearchModal />
          </SidebarGroup>
          <SidebarDivider />
          <SidebarGroup
            label="Settings"
            icon={<UserSettingsSignInAvatar />}
            to="/settings"
          >
            {nav.take('page:user-settings')}
          </SidebarGroup>
        </Sidebar>
      );
    },
  },
});
